import { CrystalWithResultDTO } from 'business/models/Models';
import { handleTableFilter } from 'components/main/userGroup/sections/baseGroup';
import { TableColumns } from '../utils';

export type GetSynchTripResultsInputFieldsParams = {
  crystal: CrystalWithResultDTO;
  handleInputChange?: (e: any, id: number) => void;
};

export type SynchTripResultInputs = {
  name: string;
  type: string;
  label?: string;
  symbol?: string;
  value?: any;
  isDisabled?: boolean;
  onChange?: (e: any, index: number) => void;
};

export const resultTableColumns: TableColumns[] = [
  {
    accessor: 'id',
    Header: 'ID',
    Filter: handleTableFilter('ID'),
    className: 'truncate synch_id',
  },
  {
    accessor: 'crystalName',
    Header: 'Crystal Name',
    Filter: handleTableFilter('Crystal Name'),
    className: 'truncate synch_name',
  },
  {
    accessor: 'owner',
    Header: 'Owner',
    Filter: handleTableFilter('Owner'),
    className: 'truncate',
  },
  {
    accessor: 'puckName',
    Header: 'Puck Name',
    Filter: handleTableFilter('Puck Name'),
    className: 'truncate synch_welldrop',
  },
  {
    accessor: 'puckBarcode',
    Header: 'Puck Barcode',
    Filter: handleTableFilter('Puck Barcode'),
    className: 'truncate',
  },
  {
    accessor: 'position',
    Header: 'Position',
    Filter: handleTableFilter('Position'),
    className: 'truncate',
  },
  {
    accessor: 'dewarName',
    Header: 'Dewar',
    Filter: handleTableFilter('Dewar'),
    className: 'truncate',
  },
  {
    accessor: 'resultStatus',
    Header: 'Status',
    Filter: handleTableFilter('Status'),
    className: 'truncate',
  },
];

const getSynchTripResultsInputFieldsA = (
  params: GetSynchTripResultsInputFieldsParams,
) => {
  const { crystal, handleInputChange } = params;
  return [
    {
      label: 'Crystal Name Other(s)',
      type: 'text',
      name: 'crystalNameInternal',
      value: crystal?.result?.crystalNameInternal || '',
      onChange: handleInputChange,
    },
    {
      label: 'Date Frozen',
      type: 'text',
      name: 'dateFrozen',
      value: crystal?.dateFrozen?.toLocaleDateString() || '',
      onChange: handleInputChange,
      isDisabled: true,
    },
    {
      label: 'PDB ID',
      type: 'text',
      name: 'e21',
      value: crystal?.result?.e21 || '',
      onChange: handleInputChange,
    },
    {
      label: 'Symm/Space Group',
      type: 'text',
      name: 'symm',
      value: crystal?.result?.symm || '',
      onChange: handleInputChange,
    },
    {
      label: 'xtal_run',
      type: 'text',
      name: 'xtalRun',
      value: crystal?.result?.xtalRun || '',
      onChange: handleInputChange,
    },
  ];
};

const getSynchTripResultsInputFieldsB = (
  params: GetSynchTripResultsInputFieldsParams,
) => {
  const { crystal, handleInputChange } = params;
  return [
    {
      label: 'Reso_lo/hi_shells',
      type: 'text',
      name: 'resoLow',
      value: crystal?.result?.resoLow || '',
      onChange: handleInputChange,
    },
    {
      label: '',
      type: 'text',
      name: 'hiShells',
      value: crystal?.result?.hiShells || '',
      onChange: handleInputChange,
    },
  ];
};

const getSynchTripResultsInputFieldsC = (
  params: GetSynchTripResultsInputFieldsParams,
) => {
  const { crystal, handleInputChange } = params;
  return [
    {
      label: 'a',
      symbol: 'Å',
      type: 'text',
      name: 'cellA',
      value: crystal?.result?.cellA || '',
      onChange: handleInputChange,
    },
    {
      label: 'b',
      symbol: 'Å',
      type: 'text',
      name: 'cellB',
      value: crystal?.result?.cellB || '',
      onChange: handleInputChange,
    },
    {
      label: 'c',
      symbol: 'Å',
      type: 'text',
      name: 'cellC',
      value: crystal?.result?.cellC || '',
      onChange: handleInputChange,
    },
    {
      label: 'α',
      symbol: '°',
      type: 'text',
      name: 'cellAlpha',
      value: crystal?.result?.cellAlpha || '',
      onChange: handleInputChange,
    },
    {
      label: 'β',
      symbol: '°',
      type: 'text',
      name: 'cellBeta',
      value: crystal?.result?.cellBeta || '',
      onChange: handleInputChange,
    },
    {
      label: 'γ',
      symbol: '°',
      type: 'text',
      name: 'cellGamma',
      value: crystal?.result?.cellGamma || '',
      onChange: handleInputChange,
    },
  ];
};

const getSynchTripResultsInputFieldsD = (
  params: GetSynchTripResultsInputFieldsParams,
) => {
  const { crystal, handleInputChange } = params;
  return [
    {
      label: 'R, R-free',
      type: 'text',
      name: 'raddamRfree',
      value: crystal?.result?.raddamRfree || '',
      onChange: handleInputChange,
    },
    {
      label: '%comp_ell',
      type: 'text',
      name: 'compEll',
      value: crystal?.result?.compEll || '',
      onChange: handleInputChange,
    },
    {
      label: '%comp_sph',
      type: 'text',
      name: 'compSph',
      value: crystal?.result?.compSph || '',
      onChange: handleInputChange,
    },
  ];
};

const getSynchTripResultsInputFieldsE = (
  params: GetSynchTripResultsInputFieldsParams,
) => {
  const { crystal, handleInputChange } = params;
  return [
    {
      label: '%Rmeas',
      type: 'text',
      name: 'rmeas',
      value: crystal?.result?.rmeas || '',
      onChange: handleInputChange,
    },
    {
      label: 'Fo-Fc',
      type: 'text',
      name: 'foFc',
      value: crystal?.result?.foFc || '',
      onChange: handleInputChange,
    },
    {
      label: 'CC1/2',
      type: 'text',
      name: 'cc12',
      value: crystal?.result?.cc12 || '',
      onChange: handleInputChange,
    },
    {
      label: 'I/sigmaI',
      type: 'text',
      name: 'isigma',
      value: crystal?.result?.isigma || '',
      onChange: handleInputChange,
    },
    {
      label: 'Refinement Program',
      type: 'text',
      name: 'refinementProgram',
      value: crystal?.result?.refinementProgram || '',
      onChange: handleInputChange,
    },
  ];
};

export type inputSections = 'A' | 'B' | 'C' | 'D' | 'E';

export const getSynchTripResultInputFields = (
  section: inputSections,
  params: GetSynchTripResultsInputFieldsParams,
) => {
  const fieldsSectionLookup = {
    A: getSynchTripResultsInputFieldsA(params),
    B: getSynchTripResultsInputFieldsB(params),
    C: getSynchTripResultsInputFieldsC(params),
    D: getSynchTripResultsInputFieldsD(params),
    E: getSynchTripResultsInputFieldsE(params),
  };
  return fieldsSectionLookup[section];
};
